import { StatementType } from "./index.js";
import { isAddValue, isAlterTableAddOnly, isCommaToken, isConstraintValue, isKeyValue, isLeftParentToken, isNewStatement, isPeriodToken, isPrimaryValue, isSemicolonToken, isStringToken, isTableValue, matchKeyModifiers, matchUsingIndexName } from "../helper.js";
import { indexColumnsParser } from "./index.columns.js";
//#region ../schema-sql-parser/dist/parser/statement/alter.table.add.primaryKey.js
function alterTableAddPrimaryKeyParser(tokens, $pos) {
	const newStatement = isNewStatement(tokens);
	const isSemicolon = isSemicolonToken(tokens);
	const isString = isStringToken(tokens);
	const isLeftParent = isLeftParentToken(tokens);
	const isConstraint = isConstraintValue(tokens);
	const isPrimary = isPrimaryValue(tokens);
	const isPeriod = isPeriodToken(tokens);
	const isKey = isKeyValue(tokens);
	const isTable = isTableValue(tokens);
	const isComma = isCommaToken(tokens);
	const isAdd = isAddValue(tokens);
	const keyModifiers = matchKeyModifiers(tokens);
	const usingIndexName = matchUsingIndexName(tokens);
	const isOnly = isAlterTableAddOnly(tokens)($pos.value);
	const isToken = () => $pos.value < tokens.length;
	const ast = {
		type: StatementType.alterTableAddPrimaryKey,
		name: "",
		constraintName: "",
		usingIndexName: "",
		columnNames: []
	};
	let keyRead = false;
	let keyClause = true;
	$pos.value++;
	while (isToken() && !newStatement($pos.value)) {
		let token = tokens[$pos.value];
		if (isSemicolon($pos.value)) {
			$pos.value++;
			break;
		}
		if (isTable($pos.value)) {
			token = tokens[++$pos.value];
			if (isOnly) token = tokens[++$pos.value];
			if (isString($pos.value)) {
				ast.name = token.value;
				$pos.value++;
				while (isPeriod($pos.value)) {
					if (!isString($pos.value + 1)) {
						$pos.value++;
						break;
					}
					ast.name = tokens[$pos.value + 1].value;
					$pos.value += 2;
				}
			}
			continue;
		}
		if (keyRead && (isComma($pos.value) || isAdd($pos.value))) keyClause = false;
		if (isConstraint($pos.value)) {
			token = tokens[++$pos.value];
			if (isString($pos.value) && !isPrimary($pos.value)) {
				if (!keyRead) ast.constraintName = token.value;
				$pos.value++;
			}
			continue;
		}
		const usingIndex = usingIndexName($pos.value);
		if (usingIndex) {
			if (keyRead && keyClause) ast.usingIndexName = tokens[$pos.value + usingIndex - 1].value;
			$pos.value += usingIndex;
			continue;
		}
		if (isPrimary($pos.value)) {
			token = tokens[++$pos.value];
			if (isKey($pos.value)) {
				token = tokens[++$pos.value];
				$pos.value += keyModifiers($pos.value);
				if (isLeftParent($pos.value)) {
					ast.columnNames = indexColumnsParser(tokens, $pos).map((indexColumn) => indexColumn.name);
					keyRead = true;
				}
			}
			continue;
		}
		$pos.value++;
	}
	return ast;
}
//#endregion
export { alterTableAddPrimaryKeyParser };
